import { khoHangSearchColumns, QUERY_KEYS, vatTuSearchColumns, viTriSearchColumns } from '@/constants';
import { FormField, SearchField, UnitDropdown } from '@/components/custom/erp';
import { MaterialUnitSearchFields } from './useSearchFieldStates';
import { KhoHang, VatTu, ViTri } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface FormDialogProps {
  mode: FormMode;
  searchFields: MaterialUnitSearchFields;
}

function BasicInfo({ mode, searchFields }: FormDialogProps) {
  const isViewMode = mode === 'view';
  const { material, warehouse, location, setmaterial, setwarehouse, setLocation } = searchFields;
  return (
    <div className='min-w-[40vw] space-y-3 p-6'>
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <UnitDropdown formMode={mode} labelClassName='w-40 min-w-40' />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã vật tư</Label>
        <div>
          <SearchField<VatTu>
            type='text'
            displayRelatedField={'ten_vt'}
            columnDisplay={'ma_vt'}
            searchEndpoint={`/${QUERY_KEYS.VAT_TU}`}
            searchColumns={vatTuSearchColumns}
            dialogTitle='Danh mục vật tư'
            value={material?.ma_vt || ''}
            relatedFieldValue={material?.ten_vt || ''}
            onRowSelection={setmaterial}
            disabled={isViewMode}
            className='w-100'
          />
        </div>
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã kho</Label>
        <div>
          <SearchField<KhoHang>
            type='text'
            displayRelatedField={'ten_kho'}
            columnDisplay={'ma_kho'}
            searchEndpoint={`/${QUERY_KEYS.KHO_HANG}`}
            searchColumns={khoHangSearchColumns}
            dialogTitle='Danh mục kho'
            value={warehouse?.ma_kho || ''}
            relatedFieldValue={warehouse?.ten_kho || ''}
            onRowSelection={setwarehouse}
            disabled={isViewMode}
            className='w-100'
          />
        </div>
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã vị trí</Label>
        <div>
          <SearchField<ViTri>
            type='text'
            displayRelatedField={'ten_vi_tri'}
            columnDisplay={'ma_vi_tri'}
            searchEndpoint={`/${QUERY_KEYS.VI_TRI_KHO_HANG}`}
            searchColumns={viTriSearchColumns}
            dialogTitle='Danh mục vị trí'
            value={location?.ma_vi_tri || ''}
            relatedFieldValue={location?.ten_vi_tri || ''}
            onRowSelection={setLocation}
            disabled={isViewMode}
            className='w-100'
          />
        </div>
      </div>
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label htmlFor='status' className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>
          Trạng thái
        </Label>
        <FormField
          id='status'
          type='select'
          name='status'
          options={[
            { label: '1. Còn sử dụng', value: '1' },
            { label: '0. Không sử dụng', value: '0' }
          ]}
          disabled={mode === 'view'}
        />
      </div>
    </div>
  );
}

export default BasicInfo;
